import * as z from "zod";

export const subjectFormSchema = z.object({
  zone_id: z.string(),
  identifier: z.string(),
  name: z.string().nullable(),
  sex: z.enum(["male", "female"], {
    message: "error_message_missing_sex",
  }),
  birth_year: z.coerce.number<number>(),
  custom_fields: z.record(z.string(), z.any().optional()),
});

export type SubjectFormSchema = z.infer<typeof subjectFormSchema>;
